module.exports = __webpack_public_path__ + "static/img/c1.7ea66b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c1.png
// module id = mSHj
// module chunks = 1